import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade} from 'swiper/modules';
import 'swiper/css';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function initVisitCardMediaGallery() {
    document.querySelectorAll('.swiper--visit-gallery').forEach((swiperEl) => {
        if (swiperEl.swiper) return;

        const nextEl = swiperEl.querySelector('.swiper__next');
        const prevEl = swiperEl.querySelector('.swiper__prev');
        const paginationEl = swiperEl.querySelector('.swiper__pagination-inner');

        new Swiper(swiperEl, {
            modules: [Navigation, Pagination, EffectFade],

            slidesPerView: 1,
            loop: true,
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // 🚫 Disable swipe
            allowTouchMove: false,
            simulateTouch: false,

            navigation: {
                nextEl,
                prevEl,
            },

            pagination: {
                el: paginationEl,
                type: 'fraction',

                formatFractionCurrent: (number) => {
                    return number < 10 ? `0${number}` : number;
                },

                formatFractionTotal: (number) => {
                    return number < 10 ? `0${number}` : number;
                },

                renderFraction(currentClass, totalClass) {
                    return `
                        <span class="${currentClass}"></span>
                        <span class="swiper__fraction-separator">-</span>
                        <span class="${totalClass}"></span>
                    `;
                },
            },
        });

        // const slides = swiperEl.querySelectorAll('.visit-gallery-slide');

        //     slides.forEach(slide => {
        //     slide.addEventListener('click', function () {

        //         const group = slide.dataset.group;
        //         const startIndex = parseInt(slide.dataset.index);

        //         // collect all slides from same group
        //         const groupSlides = document.querySelectorAll(
        //         `.visit-gallery-slide[data-group="${group}"]`
        //         );

        //         const items = [];

        //         groupSlides.forEach(s => {
        //         items.push({
        //             src: s.dataset.src,
        //             type: "image"
        //         });
        //         });

        //         Fancybox.show(items, {
        //         startIndex: startIndex,
        //         Thumbs: {
        //             autoStart: true
        //         },
        //         Toolbar: {
        //             display: ["zoom", "thumbs", "close"],
        //         },
        //         });
        //     });
        // });
    });
}

Fancybox.bind(".visit-card__gallery [data-fancybox]", {
    Thumbs: {
        autoStart: true,
    },
    Toolbar: {
        display: ["zoom", "thumbs", "close"],
    },
});

document.addEventListener('DOMContentLoaded', 
  initVisitCardMediaGallery()
);